import { AgentsSlice } from './types/AgentSliceType'

export const getCommonAgents = (state: AgentsSlice) => state.commonAgents.data

export const getCustomAgents = (state: AgentsSlice) => state.customAgents.data

export const getProviderAgents = (state: AgentsSlice) => state.providerAgents.data
